var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.listData.length
        ? _c(
            "div",
            {
              ref: "list-box",
              style: {
                height: `calc(100vh - ${_vm.total > 100 ? "200" : "248"}px)`,
              },
            },
            [
              _vm.currentLayout === "block"
                ? _c(
                    "div",
                    { staticClass: "list-box" },
                    [
                      _vm._l(_vm.listData, function (item) {
                        return _c("list-item", {
                          key: item.planId,
                          class: {
                            slide: Number(_vm.planIdShow) === item.planId,
                          },
                          attrs: { itemData: item },
                        })
                      }),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.remainder == 2 || _vm.remainder == 1,
                            expression: "remainder==2 || remainder==1",
                          },
                        ],
                        staticClass: "bef",
                      }),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.remainder == 1,
                            expression: "remainder==1",
                          },
                        ],
                        staticClass: "bef",
                      }),
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "table-box" },
                    [
                      _c("c-table", {
                        attrs: {
                          tableData: _vm.listData,
                          ISChangeCheckout: false,
                          tableHeader: _vm.planTableHeader,
                          TableHeight: `calc( 100vh - ${
                            _vm.total < 100 ? 240 : 280
                          }px )`,
                        },
                        on: { operation: _vm.operation },
                      }),
                    ],
                    1
                  ),
            ]
          )
        : _c("null-list"),
      _c("paging", {
        attrs: { total: _vm.total, pageNo: _vm.pageNo },
        on: {
          currentChange: (pageNo) => {
            this.pageNo = pageNo
            _vm.getList("pageNo")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }